import {APP_ELEMENT} from "./utils/constants";
import {ready} from "./pow/integration";
import './elements/app'
import {debug} from "./utils/log";
import {requestValidation, waitForInitialState} from "@@context";


export function init() {
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", bootstrap);
    } else {
        bootstrap().then()
    }
    // If the page was restored from bfcache, re-run the bootstrap
    window.addEventListener("pageshow", bootstrap);
    // ... to be on the safe side
    window.addEventListener("load", bootstrap);
}

async function bootstrap() {
    debug(`Initializing...`);
    await waitForInitialState
    if (!document.querySelector(APP_ELEMENT)) {
        document.body.appendChild(document.createElement(APP_ELEMENT));
        debug(`Element <${APP_ELEMENT} /> added to the DOM.`);
    }
    ready()
    await requestValidation()
}
